export default __webpack_public_path__ + "static/media/menu_bar_top_line.a322f34b.png";